// extracted by mini-css-extract-plugin
export var back = "courses-module--back--a05f2";
export var backIcon = "courses-module--back-icon--dab9d";
export var container = "courses-module--container--70651";
export var header = "courses-module--header--6cd7a";
export var list = "courses-module--list--55c32";
export var loader = "courses-module--loader--693ff";
export var message = "courses-module--message--404c9";
export var switcher = "courses-module--switcher--75b05";
export var title = "courses-module--title--3802d";